var _use, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinkedinPink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#linkedin-pink_svg__path0_fill",
    fill: "#A51457"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "linkedin-pink_svg__path0_fill",
    fillRule: "evenodd",
    d: "M2.1 0h23.8c1.167 0 2.1.933 2.178 2.022v23.956c0 1.089-.933 2.022-2.1 2.022H2.1C.933 28 0 27.067 0 25.978V2.022C0 .933.933 0 2.1 0zm2.023 10.5h4.122v13.378H4.123V10.5zm2.1-6.611A2.424 2.424 0 018.632 6.3a2.423 2.423 0 01-2.41 2.411 2.423 2.423 0 01-2.412-2.41c0-1.401 1.09-2.412 2.411-2.412zm4.666 6.611h3.966v1.789h.079c.544-1.09 1.944-2.178 3.966-2.178 4.2 0 4.978 2.8 4.978 6.378V23.8h-4.122v-6.533c0-1.556 0-3.578-2.178-3.578s-2.489 1.711-2.489 3.422v6.611h-4.2V10.5z"
  }))));
}

export default "/assets/ecs/lno/ecs-lno-frontend-concierge/3.6.2/_next/static/images/linkedin-pink-407ef5f6d81040c6e1425bad0855ad40.svg";
export { SvgLinkedinPink as ReactComponent };